module.exports = __webpack_public_path__ + "img/successkid.d385bf0f.jpeg";